import { VerifyEcoaAccessTokenRequest, VerifyEcoaAccessTokenResponse } from "./EcoaAccessToken.dto";
import { EcoaAccessTokenUrl } from "./EcoaAccessToken.url";
import { restReq } from "../../common/cyan.types";
import { FxApiRequestData, FxRequestData } from "../../common/flax.types";

export class EcoaAccessTokenFlax {
  public static verifyEcoaAccessToken(data: FxRequestData<VerifyEcoaAccessTokenRequest>): FxApiRequestData<VerifyEcoaAccessTokenResponse> {
    return {
      ...restReq(process.env.REACT_APP_CDMS_BE_URL, EcoaAccessTokenUrl.verifyEcoaAccessToken, data),
      reducer: resp => resp,
      errReducer: resp => resp,
    };
  }
}
